import GuidedOnboardingPage from "./GuidedOnboardingPage.js";

/**
 * Client onboarding is the four-step gross-first path. Expense setup remains
 * behind the separate expense gate and cannot be reopened with an old URL.
 */
export default function OnboardingPage(): React.ReactElement {
  return <GuidedOnboardingPage />;
}
